import axios from "axios";
import { getAPIUrl } from "../config";

const api = axios.create({
  baseURL: getAPIUrl(),
});

const foodstuffService = {
  async getFoodstuffs(page, size, name, withBarcode, withBrand, status) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get("/v1/foodstuffs", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          size,
          name_or_brand: name || null,
          with_brand: withBrand === true || withBrand === false ? withBrand : undefined,
          with_barcode: withBarcode === true || withBarcode === false ? withBarcode : undefined,
          ...(status ? { status } : {}),
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar lista de alimentos");
    }
  },

  async getUnverifiedFoodstuffs(page, size, name) {
    return this.getFoodstuffs(page, size, name, null, null, "UNVERIFIED");
  },
  
  async getFoodstuffSuggestions(page, size) {
    const token = localStorage.getItem("token");
    try {
      const response = await api.get("/v1/foodstuff-suggestions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          size,
          status: 'CREATED',
        }
      });

      return response.data;
    }
    catch (error) {
      throw new Error("Erro ao buscar sugestões de alimentos");
    }
  },

  async getFoodstuffSuggestionsByUser(userId, page, size, status) {
    const token = localStorage.getItem("token");

    try {
      const params = {
        page,
        size,
        created_by: userId,
      };

      if (status) {
        params.status = status;
      }

      const response = await api.get("/v1/foodstuff-suggestions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar solicitações do usuário");
    }
  },

  async getFoodstuffSuggestionsSummary(userId) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get("/v1/foodstuff-suggestions/summary", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          created_by: userId,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar resumo de solicitações");
    }
  },

  async getFoodstuffSuggestionById(id) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/foodstuff-suggestions/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar solicitação de alimento");
    }
  },

  async recognizeSuggestionPhoto(suggestionId, photoId) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.post(
        `/v1/foodstuff-suggestions/${suggestionId}/photos/${photoId}/recognize`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw new Error("Erro ao analisar imagem da solicitação");
    }
  },

  async getFoodstuffPhotos(page, size, tags) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get("/v1/foodstuff-photos", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          size,
          tags,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar imagens de alimentos");
    }
  },

  async getFoodstuffById(id) {
    const token = localStorage.getItem("token");

    const endpointRoute = `/v1/foodstuffs/${id}`;

    try {
      const response = await api.get(endpointRoute, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch {
      throw new Error("Erro ao buscar alimento");
    }
  },

  async createFoodstuff(foodstuff) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.post("/v1/foodstuffs", foodstuff, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.log('erro ao criar alimento', error)
      throw new Error("Erro ao criar alimento");
    }
  },

  async createFoodstuffPhoto(file, tags) {
    const token = localStorage.getItem("token");
    const formDataBody = new FormData();
    formDataBody.append("file", file);

    const response = await api.post(`/v1/foodstuff-photos?tags=${tags}`, formDataBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },

  async updateFoodstuff(id, foodstuff) {
    const token = localStorage.getItem("token");
    const endpointRoute = `/v1/foodstuffs/${id}`;

    try {
      const response = await api.patch(endpointRoute, foodstuff, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.log('erro ao atualizar alimento', error)
      throw new Error("Erro ao atualizar alimento");
    }
  },

  async deleteFoodstuff(id) {
    const token = localStorage.getItem("token");
    const endpointRoute = `/v1/foodstuffs/${id}`;

    try {
      const response = await api.delete(endpointRoute, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao deletar alimento");
    }
  },

  async recognizeNutritionalTable(file) {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await api.post(
        "/v1/foodstuffs/nutritional-table-recognition",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw new Error("Erro ao analisar tabela nutricional");
    }
  },

  async rejectFoodstuffSuggestion(id, comment, reason) {
    const token = localStorage.getItem("token");
    const endpointRoute = `/v1/foodstuff-suggestions/${id}`;

    try {
      const response = await api.patch(endpointRoute, {
        comment,
        reason,
        status: "REJECTED",
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao rejeitar sugestão de alimento");
    }
  }
};

export default foodstuffService;
